import { useEffect, useRef, useState } from 'react'
import { Flex, Box, Text, Card } from 'rebass/styled-components'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_LABS_LIST } from '../../graphql/queries';
import moment from 'moment';
import { Skeleton } from '../../components/loadingSkeleton/Skeleton';
import { IGetLabListResult, IGetLabsListInput, IGetLabsListOutput } from '../../graphql/types/queries/charts';
import Modal from 'styled-react-modal';
import LabDocumentViewer from './LabDocumentViewer';
import { useIsVisible } from '../../hooks/useIsVisible';
import { SpecialModalBackground } from '../../components/Commons';
import styled from 'styled-components';
import { EnhancedModal } from '../../components/EnhancedModal';
import { KitStatus } from './components/KitStatus';
import { useCollapse } from 'react-collapsed';


const Wrapper = styled(Flex)`
  overflow: auto;
  width: auto;
  padding-right: 20px;
  margin-right: 20px;
  padding-left: 40px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  marginLeft: '90px',
  boxShadow: 'initial'
}

const contentStyle = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginLeft: '120px',
  marginRight: '80px',
  marginBottom: '24px',
}

const contentMobileStyle = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginLeft: '120px',
  marginBottom: '24px',
  marginRight: '40px'
}

const contentArrowStyle = {
  borderRight: '7px solid  #F0F5FD',
}

const LabDisplayLoading = () => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex>
        <Flex flexDirection={'column'} width='120px' justifyContent={'center'} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={400} fontSize='14px'><Skeleton height={19} width={90} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='12px'><Skeleton height={16} width={100} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} />
        <Flex flexDirection={'column'} width='180px' justifyContent={'center'} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'><Skeleton height={16} width={112} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='14px'><Skeleton height={19} width={112} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} />
        <Flex flexDirection={'column'} flex={1} justifyContent={'center'} alignItems='flex-start' paddingX={'12px'}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'><Skeleton height={16} width={75} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='14px'><Skeleton height={19} width={163} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const normalizeAnalyteName = (analyte: string) => {
  const lowered = analyte.toLowerCase().replace(/ /g, '');

  if (lowered.indexOf('t3') > -1) {
    if (lowered.indexOf('rt3') > -1 || lowered.indexOf('reverse') > -1) {
      return 'Reverse T3';
    }
    if (lowered.indexOf('ft3') > -1 || lowered.indexOf('free') > -1) {
      return 'Free T3';
    }
  }

  if (lowered.indexOf('t4') > -1) {
    if (lowered.indexOf('ft4') > -1 || lowered.indexOf('free') > -1) {
      return 'Free T4';
    }
  }

  if (lowered.indexOf('tpo') > -1 || lowered.indexOf('thyroidperoxidase') > -1) {
    return 'TPO';
  }

  if (lowered.indexOf('tsh') > -1) {
    return 'TSH';
  }

  if (lowered.indexOf('vitamind') > -1) {
    return 'Vitamin D';
  }

  return analyte;
  // switch (analyte.toLowerCase().replace(/ /g, '')) {
  //   case 'ft3':
  //   case 'ft3-bloodspot':
  //   case 'freet3':
  //   case 'freet3uptake':
  //   case 't3,free':
  //   case 't3free':
  //   case 't3free(ml)':
  //   case 'triiodothyronine(t3),free':
  //     return 'Free T3'
  //   case 'ft4':
  //   case 'ft4-bloodspot':
  //   case 'freet4':
  //   case 'freet4(direct)':
  //   case 'freet4index':
  //   case 'freet4index(t7)':
  //   case 'ft4':
  //   case 't4free':
  //   case 't4,free':
  //   case 't4,free,directdialysis':
  //   case 't4,free(direct)':
  //     return 'Free T4'
  //   case 'tpo':
  //   case 'tpo-bloodspot':
  //   case 'tpoab':
  //   case 'tpoanitbody':
  //   case 'tpoantibodies':
  //   case 'tpoantibody':
  //   case 'thyroidperoxidaseantibodies':
  //   case 'thyroidperoxidase(tpo)ab':
  //     return 'TPO'
  //   case 'tsh':
  //   case 'tsh-bloodspot':
  //   case 'tsh-icma':
  //     return 'TSH'
  //   case 'rt3':
  //   case 'rt3-bloodspot':
  //   case 'reverset3':
  //   case 't3reverse':
  //   case 't3reverse,lc/ms/ms':
  //   case 't3,reverse':
  //     return 'Reverse T3'
  //   case 'vitamind':
  //   case 'vitamind-bloodspot':
  //   case 'vitamind,25-oh,total':
  //   case 'vitamind,25-oh,total,ia':
  //   case 'vitamind,25-hydroxy':
  //   case 'vitamind,25-ohtotal':
  //     return 'Vitamin D'
  //   default:
  //     return analyte
  // }
}

const KitPendingDisplay: React.FC<{ isMinimized?: boolean, x: IGetLabListResult, setShowPendingDetails: (x: string) => void }> = ({ isMinimized, x, setShowPendingDetails }) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse()
  return (
    <Flex width='100%' padding={2} opacity={0.6} flexDirection={'column'}>
      <Flex flexDirection={isMinimized ? 'column' : ['column', 'row', 'row']}>
        <Text flex={1}>Paloma Thyroid Test Kit</Text>
        <Box style={{ borderRadius: '8px', backgroundColor: '#7992B3', color: 'white' }} mt={isMinimized ? 2 : 0} paddingX={2}>
          {x.status}
        </Box>
      </Flex>
      {!!x.labResultId && (
        <>
          {!!isMinimized ? (
            <Text  {...getToggleProps()} style={{ textDecoration: 'underline' }} onClick={() => {
              if (!!isMinimized) {
                setShowPendingDetails(x.labResultId!.toString())
              } else {

              }
            }}>View Details</Text>
          ) : (<Text  {...getToggleProps()} style={{ textDecoration: 'underline' }}>{!isExpanded ? 'View Details' : 'Hide Details'}</Text>)}
        </>
      )}
      <div  {...getCollapseProps()}>
        {!!x.labResultId && !!isExpanded &&
          <KitStatus labResultId={x.labResultId.toString()} />}
      </div>
    </Flex>
  )
}

const LabDisplay = ({ item, onClick, isMinimized }: { item: IGetLabListResult, onClick: () => void, isMinimized?: boolean }) => {
  const calcValue = (value: string | undefined) => {
    if (!value || value === '-') {
      return '-'
    }
    try {
      let v = parseFloat(value)
      if (isNaN(v)) return value
      return parseFloat(v.toFixed(2)).toString()
    } catch (error) {
      return value
    }
  }
  return (
    <Flex flexDirection={'column'} width='100%' paddingX={2} style={{ cursor: !!item.attachmentExists ? 'pointer' : '' }} onClick={onClick}>
      {item.analytes.length > 0 ? (
        <>
          <Flex>
            <Flex flexDirection={'column'} flex={1} justifyContent={'center'} >
              <Flex flexDirection={'column'}>
                <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Analyte</Text>
              </Flex>
            </Flex>
            <Box style={{ height: '28px', background: '#E2E2E2', width: '1px' }} marginX={2} />
            <Flex flexDirection={'column'} width='140px' justifyContent={'center'} >
              <Flex flexDirection={'column'}>
                <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Value</Text>
              </Flex>
            </Flex>
            {!isMinimized && (
              <>
                <Box style={{ height: '28px', background: '#E2E2E2', width: '1px' }} marginX={2} />
                <Flex flexDirection={'column'} width='200px' justifyContent={'center'} alignItems='flex-start' >
                  <Flex width={'100%'} alignItems='center'>
                    <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Lab</Text>
                  </Flex>
                </Flex>
              </>
            )}
          </Flex>
          {item.analytes.map(x => {
            return (<Flex key={x.id}>
              <Flex flexDirection={'column'} flex={1} justifyContent={'center'} >
                <Flex flexDirection={'column'}>
                  <Text fontWeight={400} fontSize='14px' color={!!x.status && x.status !== 'normal' ? '#F24D2F' : ''}>{normalizeAnalyteName(x.analyte)}</Text>
                </Flex>
              </Flex>
              <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} marginX={2} />
              <Flex flexDirection={'column'} width='140px' justifyContent={'center'} >
                <Flex flexDirection={'column'}>
                  <Text fontWeight={400} fontSize='14px' color={!!x.status && x.status !== 'normal' ? '#F24D2F' : ''}>{calcValue(x.value)} {x.unit}</Text>
                </Flex>
              </Flex>
              {!isMinimized && (
                <>
                  <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} marginX={2} />
                  <Flex flexDirection={'column'} width='200px' justifyContent={'center'} alignItems='flex-start' >
                    <Flex width={'100%'} alignItems='center'>
                      <Text fontWeight={300} fontSize='14px' flex={1}>{(item.lab || ' ').split(' ')[0]}</Text>
                      <Box style={{ borderRadius: '8px', backgroundColor: !x.status ?'':x.status === 'normal' ? '#BCFFEB' : '#FFD2CA', fontSize: '12px' }} paddingX={2}>
                        {x.status}
                      </Box>
                    </Flex>
                  </Flex>
                </>
              )}
            </Flex>)
          })}
        </>) : (
        <Text>View Document</Text>
      )}
      {!!item.attachmentExists && (
        <svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: -40 }}>
          <path d="M20.3496 6.58301C20.5254 6.75879 20.625 6.99609 20.625 7.24512V25.3125C20.625 25.8311 20.2061 26.25 19.6875 26.25H0.9375C0.418945 26.25 0 25.8311 0 25.3125V0.9375C0 0.418945 0.418945 0 0.9375 0H13.3799C13.6289 0 13.8691 0.0996094 14.0449 0.275391L20.3496 6.58301ZM18.4629 7.67578L12.9492 2.16211V7.67578H18.4629ZM13.8639 16.7947C13.4191 16.7801 12.9463 16.8144 12.4093 16.8814C11.6974 16.4423 11.2181 15.8391 10.8776 14.9528L10.909 14.8245L10.9453 14.6728C11.0713 14.1416 11.139 13.754 11.1592 13.3632C11.1744 13.0682 11.158 12.796 11.1056 12.5437C11.0089 11.9991 10.6236 11.6807 10.1382 11.661C9.68555 11.6426 9.26953 11.8954 9.16318 12.2871C8.99004 12.9205 9.09141 13.754 9.4585 15.1755C8.99092 16.2902 8.37305 17.5972 7.9585 18.3261C7.40508 18.6114 6.97412 18.871 6.61201 19.1587C6.13447 19.5387 5.83623 19.9292 5.7542 20.3394C5.71436 20.5295 5.77441 20.7779 5.91123 20.9815C6.0665 21.2124 6.30029 21.3624 6.58066 21.3841C7.28818 21.4389 8.15771 20.7094 9.11777 19.062C9.21416 19.0298 9.31611 18.9958 9.44062 18.9536L9.78926 18.8358C10.0099 18.7614 10.1698 18.7081 10.328 18.6568C11.0136 18.4336 11.5321 18.2927 12.0038 18.2124C12.8235 18.6513 13.771 18.939 14.4091 18.939C14.9358 18.939 15.2918 18.6659 15.4204 18.2361C15.5332 17.8588 15.4438 17.4211 15.2013 17.1791C14.9505 16.9327 14.4894 16.8149 13.8639 16.7947ZM6.59854 20.557V20.5465L6.60234 20.5365C6.64521 20.4257 6.70023 20.32 6.76641 20.2213C6.8918 20.0285 7.06436 19.8258 7.27822 19.6099C7.39307 19.4941 7.5126 19.3813 7.65293 19.2548C7.68428 19.2267 7.88467 19.0482 7.92217 19.0131L8.24941 18.7084L8.01152 19.0872C7.65059 19.6626 7.32422 20.0769 7.04473 20.347C6.94189 20.4466 6.85137 20.5198 6.77812 20.567C6.75395 20.5831 6.72835 20.5971 6.70166 20.6086C6.68965 20.6136 6.6791 20.6165 6.66855 20.6174C6.65742 20.6188 6.64611 20.6173 6.63574 20.613C6.62472 20.6084 6.6153 20.6006 6.60868 20.5906C6.60206 20.5807 6.59853 20.569 6.59854 20.557ZM10.2882 14.1621L10.222 14.2793L10.181 14.151C10.0901 13.863 10.0233 13.4291 10.0049 13.0377C9.98379 12.5924 10.0192 12.3252 10.1599 12.3252C10.3573 12.3252 10.4479 12.6416 10.4549 13.1177C10.4613 13.536 10.3957 13.9714 10.2882 14.1621ZM10.118 15.8748L10.1628 15.7562L10.224 15.8675C10.5665 16.4897 11.0109 17.0089 11.4996 17.3707L11.6051 17.4486L11.4765 17.475C10.998 17.574 10.5524 17.7229 9.94307 17.9687C10.0066 17.9429 9.30967 18.2282 9.1333 18.2959L8.97949 18.3548L9.06152 18.2118C9.42334 17.5819 9.75791 16.8255 10.118 15.8748ZM14.7357 18.109C14.5055 18.1998 14.0098 18.1187 13.137 17.746L12.9155 17.6517L13.1558 17.6341C13.8384 17.5834 14.3218 17.6209 14.6036 17.724C14.7237 17.768 14.8037 17.8233 14.8392 17.8866C14.8578 17.9166 14.8641 17.9526 14.8567 17.9871C14.8492 18.0216 14.8287 18.0519 14.7993 18.0715C14.7807 18.0879 14.7591 18.1006 14.7357 18.109Z" fill="#344F7A" />
        </svg>
      )}
    </Flex>
  )
}

const LabsList = ({ patientId, isMinimized }: { patientId: string, isMinimized?: boolean }) => {
  const [showPages, setShowPages] = useState<null | {
    labResultId: number
  }>()
  const [showPendingDetails, setShowPendingDetails] = useState<string | null>(null)

  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IGetLabsListOutput, IGetLabsListInput>(GET_LABS_LIST, {
    variables: {
      patientId
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])


  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' padding={'20px'}>
      {!loading && (!data?.providersGetLabLists || data?.providersGetLabLists.length < 1) ? (
        null
      ) : (
        <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', }} paddingY={'12px'} mb={4}>

          <Flex>
            <Text fontWeight={600} fontSize='18px' m={'18px 28px'}>All Labs</Text>

          </Flex>
          <Flex>
            {!!loading ? (
              <>
                <VerticalTimeline layout='1-column' lineColor='#344F7A' >
                  {[0, 1, 2, 3].map(x => {
                    return (
                      <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={contentStyle}
                        contentArrowStyle={contentArrowStyle}
                        iconStyle={iconStyle} key={`loadingLabsList${x}`}
                      >
                        <LabDisplayLoading />
                      </VerticalTimelineElement>)
                  })}
                </VerticalTimeline>
              </>
            ) : (
              <>
                {!data?.providersGetLabLists || data?.providersGetLabLists.length < 1 ? (null) : (
                  <VerticalTimeline className='vertical-timeline--lab' layout='1-column' lineColor='#344F7A' >
                    {(JSON.parse(JSON.stringify(data?.providersGetLabLists)) as IGetLabListResult[]).sort((a, b) => {
                      if (a.status === 'pending') return -1;
                      if (b.status === 'pending') return 1;
                      if (!a.date) return 1;
                      if (!b.date) return -1;

                      const ma = moment(a.date, 'x')
                      const mb = moment(b.date, 'x')
                      if (ma.isBefore(mb)) return 1
                      return -1
                    }).map(x => {
                      return (
                        <>
                          <Box display={['none', 'initial', 'initial']}>
                            <VerticalTimelineElement
                              className="vertical-timeline-element--lab"
                              contentStyle={contentStyle}
                              date={x.status === 'pending' ? 'Pending' : !x.date ? 'N/A' : moment.utc(x.date, 'x').format('MM/DD/YYYY')}
                              contentArrowStyle={contentArrowStyle}
                              iconStyle={iconStyle} key={`loadingAppts${x}`}
                            >
                              {x.status === 'pending' ? (
                                <KitPendingDisplay isMinimized={isMinimized} x={x} setShowPendingDetails={setShowPendingDetails} />
                              ) : (
                                <LabDisplay isMinimized={isMinimized} item={x} onClick={() => {
                                  if (!x.attachmentExists || !x.labResultId) return

                                  setShowPages({
                                    labResultId: x.labResultId
                                  })
                                }} />)}
                            </VerticalTimelineElement>
                          </Box>
                          <Box display={['initial', 'none', 'none']}>
                            <VerticalTimelineElement
                              className="vertical-timeline-element--lab"
                              contentStyle={contentMobileStyle}
                              date={x.status === 'pending' ? 'Pending' : !x.date ? 'N/A' : moment.utc(x.date, 'x').format('MM/DD/YYYY')}
                              contentArrowStyle={contentArrowStyle}
                              iconStyle={iconStyle} key={`loadingAppts${x}`}
                            >
                              {x.status === 'pending' ? (
                                <Flex width='100%' padding={2} opacity={0.6} flexDirection={['column', 'row', 'row']}>
                                  <Text flex={1}>Paloma Thyroid Test Kit</Text>
                                  <Box style={{ borderRadius: '8px', backgroundColor: '#7992B3', color: 'white' }} paddingX={2}>
                                    {x.status}
                                  </Box>
                                </Flex>
                              ) : (
                                <LabDisplay isMinimized={isMinimized} item={x} onClick={() => {
                                  if (!x.attachmentExists || !x.labResultId) return

                                  setShowPages({
                                    labResultId: x.labResultId
                                  })
                                }} />)}
                            </VerticalTimelineElement>
                          </Box>
                        </>)
                    })}
                  </VerticalTimeline>)}
              </>)}
          </Flex>
        </Flex>
      )}
      {!!showPages && (
        <Modal
          isOpen={!!showPages}
          onBackgroundClick={() => setShowPages(null)}
          onEscapeKeydown={() => setShowPages(null)}>
          <Flex
            flexDirection={'column'}
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '96',
              height: '96%',
              width: '700px',
              maxWidth: '96%',
              overflow: 'hidden',
              paddingTop: '4px',
              paddingRight: 0
            }}>
            <Flex justifyContent='flex-end' style={{ borderBottom: '1px solid rgb(229, 233, 236)' }}>
              <Text mb={1} mt={1} mr={2} style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setShowPages(null)}>Close</Text>
            </Flex>
            <LabDocumentViewer labResultId={showPages!.labResultId} patientId={patientId} />
          </Flex>
        </Modal>
      )}
      {!!showPendingDetails && (
        <Modal
          isOpen={!!showPendingDetails}
          onBackgroundClick={() => {
            setShowPendingDetails(null)
          }}
          onEscapeKeydown={() => {
            setShowPendingDetails(null)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setShowPendingDetails(null)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: '500px',
                maxHeight: '95vh',
                minHeight: '90px',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} style={{ overflowY: 'auto' }}>
                <KitStatus labResultId={showPendingDetails} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Flex>)

}

export default LabsList